import React from 'react'
import { format, parse, addDays } from 'date-fns'

export const formatDate = (
  dateStr: string | null,
  dateFormat = 'MM/dd/yyyy'
) => {
  let formatedDate = ''
  try {
    if (dateStr) {
      formatedDate = format(parse(dateStr, 'yyyyMMdd', new Date()), dateFormat)
    }
  } catch (err) {
    formatedDate = ''
  }

  return formatedDate
}

export const addFormattedDays = (
  dateStr: string,
  days: number,
  dateFormat = 'yyyyMMdd'
) => {
  if (dateStr) {
    return format(
      addDays(parse(dateStr, 'yyyyMMdd', new Date()), days),
      dateFormat
    )
  }
  return ''
}

const now = Date.now()
export const defaultToday = format(now, 'yyyyMMdd')
export const defaultTomorrow = format(addDays(now, 1), 'yyyyMMdd')
export const defaultMaxDate = format(addDays(now, 330), 'yyyyMMdd')

// Shared methods for Flights, SOPQ Flights and RC
/**
 * @param {object} param0
 * @param {string | null} [param0.departureDate]
 * @param {string | null} [param0.arrivalDate] - The name of the employee.
 * @param {boolean} isOneWay
 */
export const getDateRange = (
  {
    departureDate = null,
    arrivalDate = null
  }: { departureDate: string | null; arrivalDate: string | null },
  isOneWay: boolean
) => {
  if (!departureDate) return ''
  const start = formatDate(departureDate)
  if (isOneWay) return start
  const end = formatDate(arrivalDate)
  return `${start} – ${end}`
}

export const getPackagesDateRange = ({
  startDate,
  endDate
}: {
  startDate: string | null
  endDate: string | null
}) => {
  if (!startDate) return ''
  return `${formatDate(startDate)} - ${formatDate(endDate)}`
}

export const getHotelDateRange = ({
  startDate,
  endDate
}: {
  startDate: string | null
  endDate: string | null
}) => {
  if (!startDate && !endDate) return ''
  const start = formatDate(startDate)
  const end = formatDate(endDate)
  return [start, end].join(' – ')
}

export const getRcMinDate = (pickupDate?: string) => {
  if (pickupDate) {
    return formatDate(pickupDate, 'yyyyMMdd')
  }
  return format(new Date(), 'yyyyMMdd')
}

export const getRcMaxDate = (dropoffDate?: string) => {
  if (dropoffDate) {
    return formatDate(dropoffDate, 'yyyyMMdd')
  }
  return format(addDays(new Date(), 330), 'yyyyMMdd')
}

export const getTimeOptions = () => {
  const times = new Array(48).fill(null).map((_, i) => i)

  return times.map(time => {
    const date = new Date(
      0,
      0,
      0,
      Math.floor(time / 2),
      time % 2 === 0 ? 0 : 30
    )
    const value = format(date, 'HH:mm')
    let label = format(date, 'h:mm a')
    if (value === '00:00') {
      label = 'Midnight'
    } else if (value === '12:00') {
      label = 'Noon'
    }
    return (
      <option key={value} value={value}>
        {label}
      </option>
    )
  })
}
